import {UmpireTransmissionProvider} from '../umpire-transmission-provider';
import {UmpireIncident} from '../umpire-incident';
import {UmpireMatch} from '../umpire-match';
import {UmpireSquad} from '../umpire-squad';

export interface UmpireLineups {
  type: string;

  id: string;

  start_time: string | null;

  incidents: UmpireIncident[];

  transmission_providers: UmpireTransmissionProvider[];

  lineups: UmpireLineup[];
}

export interface UmpireLineup {
  id: string;

  squad: UmpireSquad;

  match: Partial<UmpireMatch>;

  squad_players: UmpireLineupPlayer[];
}

export interface UmpireLineupPlayer {
  squad_player_id: string;

  starting_position: UmpireLineupPlayerStartingPosition;
}

export enum UmpireLineupPlayerStartingPosition {
  FL = 'FL',
  FLC = 'FLC',
  FC = 'FC',
  FRC = 'FRC',
  FR = 'FR',
  AML = 'AML',
  AMLC = 'AMLC',
  AMC = 'AMC',
  AMRC = 'AMRC',
  AMR = 'AMR',
  ML = 'ML',
  MLC = 'MLC',
  MC = 'MC',
  MRC = 'MRC',
  MR = 'MR',
  DML = 'DML',
  DMLC = 'DMLC',
  DMC = 'DMC',
  DMRC = 'DMRC',
  DMR = 'DMR',
  DL = 'DL',
  DLC = 'DLC',
  DC = 'DC',
  DRC = 'DRC',
  DR = 'DR',
  GK = 'GK',
}
